import { RebuildHeader } from "@/components/layout/RebuildHeader";
import { NavUserDropdown } from "@/components/layout/nav-user-dropdown/NavUserDropdown";
import { SettingsSectionTabs, type SettingsSectionTab } from "@/components/settings/SettingsSectionTabs";
import { useHasAdminFeatureAccess } from "@/hooks/useHasAdminFeatureAccess";
import { ChevronLeft } from "lucide-react";
import { Navigate, NavLink, Outlet } from "react-router-dom";

/** Default tab: admins with self-serve enabled land on Manage Team; everyone else on Profile. */
export function SettingsIndexRedirect() {
  const isOrgAdmin = useHasAdminFeatureAccess("SELF_SERVE_ADMIN_ENABLED");
  return <Navigate to={isOrgAdmin ? "users" : "profile"} replace />;
}

export function SettingsLayout() {
  const isOrgAdmin = useHasAdminFeatureAccess("SELF_SERVE_ADMIN_ENABLED");
  const showManageOffices = useHasAdminFeatureAccess("MANAGE_OFFICES_ENABLED");
  const showPhotoLabels = useHasAdminFeatureAccess("PHOTO_LABELS_ENABLED");

  const sectionTabs: SettingsSectionTab[] = isOrgAdmin
    ? [
        { to: "/settings/users", label: "Manage Team", end: true },
        ...(showManageOffices
          ? [{ to: "/settings/offices", label: "Offices & Xactnet", end: true } as SettingsSectionTab]
          : []),
        ...(showPhotoLabels ? [{ to: "/settings/photo-labels", label: "Photo Labels", end: true } as SettingsSectionTab] : []),
        { to: "/settings/profile", label: "My Profile", end: true },
      ]
    : [{ to: "/settings/profile", label: "My Profile", end: true }];

  return (
    <div className="bg-background relative flex min-h-full flex-1 w-full min-w-0 flex-col">
      <RebuildHeader
        rightSection={
          <div className="flex flex-row items-center gap-2">
            <NavUserDropdown />
          </div>
        }
      />
      <div className="border-border flex min-h-0 flex-1 flex-col overflow-hidden border-t">
        <div className="border-border flex shrink-0 flex-row items-center gap-1 border-b px-4 py-2">
          <NavLink
            to="/dashboard"
            aria-label="Back to dashboard"
            className="text-muted-foreground hover:text-foreground inline-flex size-8 shrink-0 items-center justify-center rounded-md transition-colors hover:bg-muted/60"
          >
            <ChevronLeft className="size-5" />
          </NavLink>
          <div className="min-w-0 flex-1">
            <SettingsSectionTabs tabs={sectionTabs} />
          </div>
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-auto py-6 pr-4 pl-13">
          <div className="flex min-h-0 w-full flex-1 flex-col self-start">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
